import { heroItems, quickTopics, navTopics } from "@/mocks/jiukanliao";

export default function HeroSection() {
  return (
    <section id="home" className="relative overflow-hidden bg-[#fbf6ec]">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_80%_0%,#fbe3c9_0%,transparent_46%)]" />

      <div className="relative mx-auto max-w-[1440px] px-4 pt-28 pb-12 md:px-8 md:pt-36 md:pb-16 lg:grid lg:grid-cols-12 lg:gap-10">
        {/* 左侧导读 */}
        <div className="lg:col-span-4 lg:pr-6 xl:pr-10">
          <div className="animate-rise">
            <p className="inline-flex items-center gap-2 rounded-full border border-[#eccf9d] bg-[#fff6e6] px-3 py-1 text-xs font-semibold tracking-wide text-[#a86a1f]">
              <i className="ri-flashlight-line" />
              TODAY · 九宫格爆料专区
            </p>
            <h2 className="font-display mt-6 text-4xl font-black leading-[1.15] text-[#231f18] md:text-5xl">
              一张九宫格，
              <br />
              看懂<span className="text-[#d9431f]">一场瓜</span>。
            </h2>
            <p className="mt-5 max-w-md text-[15px] leading-7 text-[#6b5f48]">
              9看料 汇总图片爆料、截图合集与九图吃瓜内容。按时间轴排好的九图，配上一目了然的多图预警，让你快速锁定关键截图与现场细节。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {quickTopics.map((q) => (
                <a
                  key={q}
                  href="#hot"
                  className="whitespace-nowrap rounded-full border border-[#e2cfaa] bg-white/70 px-3.5 py-1.5 text-[13px] text-[#7a5c2e] transition hover:border-[#d9431f] hover:text-[#b43a17]"
                >
                  # {q}
                </a>
              ))}
            </div>

            <div className="mt-8 hidden items-center gap-4 lg:flex">
              <div className="flex -space-x-2">
                {["#f2b56b", "#ee7b56", "#c98a5e", "#d8b48a"].map((c) => (
                  <span
                    key={c}
                    className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-[#fbf6ec] text-[10px] font-semibold text-white"
                    style={{ backgroundColor: c }}
                  >
                    <i className="ri-user-fill text-xs" />
                  </span>
                ))}
              </div>
              <p className="text-xs leading-5 text-[#9a7f52]">
                <span className="font-semibold text-[#6b5f48]">32w+</span> 位吃瓜搭子
                <br />
                正在追更多图预警图集
              </p>
            </div>
          </div>
        </div>

        {/* 右侧多卡墙 */}
        <div className="mt-8 lg:col-span-8 lg:mt-0">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
            {heroItems.map((item, i) => {
              const isWide = i === 0;
              const isBottom = i === heroItems.length - 1;
              const span =
                isWide
                  ? "xl:col-span-2"
                  : isBottom
                    ? "sm:col-span-2 xl:col-span-2 xl:row-span-0"
                    : "";
              const ratio = isWide || isBottom ? "aspect-[16/9]" : "aspect-[4/5]";
              return (
                <a
                  key={item.title}
                  href="#hot"
                  className={`group relative overflow-hidden rounded-2xl bg-white ring-1 ring-[#eadbc0] ${span} ${isWide ? "" : ""}`}
                  style={{ animationDelay: `${i * 90}ms` }}
                >
                  <div className={`relative w-full overflow-hidden ${ratio}`}>
                    <img
                      src={item.image}
                      alt={item.title}
                      className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                    />
                    <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-[#231f18]/70 px-2.5 py-1 text-[11px] font-medium text-white backdrop-blur">
                      <i className="ri-fire-fill text-[#ffb15c]" />
                      {item.tag}
                    </span>
                    {item.alert && (
                      <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-[#d9431f] px-2 py-1 text-[10px] font-semibold text-white">
                        <i className="animate-pulse-dot inline-block h-1.5 w-1.5 rounded-full bg-white" />
                        多图预警
                      </span>
                    )}
                  </div>
                  <div className="p-4 md:p-5">
                    <h3
                      className={`font-display font-bold leading-snug text-[#231f18] ${
                        isWide ? "text-lg md:text-xl" : "text-[15px] md:text-base"
                      }`}
                    >
                      {item.title}
                    </h3>
                    <p className="mt-2 line-clamp-2 text-[13px] leading-6 text-[#8a7a5d]">
                      {item.summary}
                    </p>
                    <div className="mt-3 flex items-center gap-3 text-[11px] text-[#a48a5d]">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line" />
                        {item.views}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line" />
                        {item.time}
                      </span>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>

      {/* 底部题材滚动条 */}
      <div className="relative border-t border-[#eadbc0] bg-[#fff9f0]">
        <div className="mx-auto flex max-w-[1440px] items-center gap-4 overflow-x-auto px-4 py-3 no-scrollbar md:px-8">
          <span className="flex shrink-0 items-center gap-1.5 text-xs font-semibold tracking-wide text-[#b43a17]">
            <i className="ri-pulse-line" />
            今天在看
          </span>
          <div className="flex items-center gap-2.5 text-[13px] text-[#6b5f48]">
            {navTopics.map((t, idx) => (
              <span key={t.id} className="flex shrink-0 items-center gap-2.5">
                {idx > 0 && <span className="h-1 w-1 rounded-full bg-[#e2cfaa]" />}
                <a href="#topics" className="whitespace-nowrap transition hover:text-[#b43a17]">
                  {t.label}
                </a>
              </span>
            ))}
          </div>
          <span className="ml-auto hidden shrink-0 items-center gap-1 text-xs text-[#a48a5d] md:flex">
            <i className="ri-arrow-right-s-line" />
            持续更新中
          </span>
        </div>
      </div>
    </section>
  );
}